import { render } from "./receipt.vue?vue&type=template&id=0922afe2&scoped=true"
import script from "./receipt.vue?vue&type=script&lang=js"
export * from "./receipt.vue?vue&type=script&lang=js"

import "./receipt.vue?vue&type=style&index=0&id=0922afe2&scoped=true&lang=css"

import exportComponent from "/Users/kokleng/Documents/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0922afe2"]])

export default __exports__